import { createAction, props } from '@ngrx/store'
import { DebidaDiligenciaInterface } from '@shared/interfaces/app.state.interfaces'

export const debidaDiligencia = createAction(
    '[DebidaDiligencia] Item',
    props<{ item: DebidaDiligenciaInterface }>()

)